import { render, staticRenderFns } from "./EventBridge.vue?vue&type=template&id=3981699c&scoped=true"
import script from "./EventBridge.vue?vue&type=script&lang=ts"
export * from "./EventBridge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981699c",
  null
  
)

export default component.exports